export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  width?: any;
  height?:any;
  padding?: number;
  background?: string;
 
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
